import { render, staticRenderFns } from "./banner_clients.vue?vue&type=template&id=db5dfee6&scoped=true&"
import script from "./banner_clients.vue?vue&type=script&lang=js&"
export * from "./banner_clients.vue?vue&type=script&lang=js&"
import style0 from "./banner_clients.vue?vue&type=style&index=0&id=db5dfee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5dfee6",
  null
  
)

export default component.exports